import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BokkzIbDataService, Aangifte} from "@snelstart-ventures/fiscaal/domain-logic";
import { SharedUiButtonModule } from '@snelstart/ui-button';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-loon-buitenland',
    standalone: true,
    imports: [CommonModule, SharedUiButtonModule],
    templateUrl: './tekst-loon-buitenland.component.html',
    styleUrl: './tekst-loon-buitenland.component.scss',
})
export class TekstLoonBuitenlandComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public focusedElementId: string | null = null;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();


    constructor(
        public dataService: BokkzIbDataService) {
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((value) => {
            if (value.year !== undefined) {
                this.year = value.year;
            }
        })
    }

}
